module.exports = __webpack_public_path__ + "static/img/palm-trees.2f9111b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/backgrounds/palm-trees.jpg
// module id = bc5e
// module chunks = 1